/**
 * Codes d'alarme glider — flags combinables par OR binaire.
 * Source de vérité : docs/functional/v1-api-endpoints.md §GliderAlarmCode
 * (bits de la trame SEAALR / colonne SAL_DATA_ALR). `Ok` = absence d'alarme (0).
 */
export enum GliderAlarmCode {
  Ok = 0,
  LowVoltage = 1,
  MissionOverTime = 2,
  OverDepth = 4,
  WaterInlet = 8,
  Vacuum = 16,
  Stability = 32,
  Ballast = 64,
  LinearController = 128,
  AngularController = 256,
  Communication = 512,
  InconsistentPitchAngle = 1024,
  InconsistentDepth = 2048,
  DepthSensor = 4096,
  PayloadProblem = 8192,
  StateOverTime = 16384,
  ReleaseDevice = 32768,
  Write = 65536,
  PayloadTrigger = 131072,
  SdCard = 262144,
  GliderReboot = 524288,
}

/**
 * Convertit une chaîne de flags `GliderAlarmCode` (sérialisation WS — ex
 * `"LowVoltage, Vacuum, Ballast"`) en bitmap numérique, pour parité avec
 * `gli_alr` du snapshot REST IRIS.
 *
 * - `"Ok"`, chaîne vide, `null`/`undefined` → `0` (pas d'alarme).
 * - Les flags inconnus (jamais censés arriver) sont ignorés sans erreur.
 */
export function parseAlarmFlagsToBitmap(flags: string | null | undefined): number {
  if (!flags) return 0
  let bitmap = 0
  for (const raw of flags.split(',')) {
    const name = raw.trim()
    if (!name || name === 'Ok') continue
    const bit = (GliderAlarmCode as unknown as Record<string, number | undefined>)[name]
    if (typeof bit === 'number') bitmap |= bit
  }
  return bitmap
}
